enum UserPermission {
  CUSTOMER_SERVICE = 1,
  ADMIN = 2,
  VISITOR = 3,
}

export default UserPermission;
